module.exports = __webpack_public_path__ + "img/nova-top-angle.ac952842.png";